<i nz-icon nzType="question-circle" nz-popover [nzPopoverContent]="speedGifTpl"></i>
<ng-template #speedGifTpl>
  <img src="./assets/spearfishing/speed_{{speed}}.gif" alt="{{speed}}" style="width: 320px">
</ng-template>
